import React, { useState } from 'react'
import Stepper from '../components/general/Stepper'
import IndividualOrBusinessAccountTypes from '../components/registration/registrationSteps/IndividualOrBusinessAccountTypes'
import FirstRegistrationStep from '../components/registration/registrationSteps/FirstRegistrationStep'
import SecondRegistrationStep from '../components/registration/registrationSteps/SecondRegistrationStep'
import ThirdRegistrationStep from '../components/registration/registrationSteps/ThirdRegistrationStep'
import BusinessAccountFifthRegistrationStep from '../components/registration/registrationSteps/BusinessAccountFifthRegistrationStep'
import BasicAccountFifthRegistrationStep from '../components/registration/registrationSteps/BasicAccountFifthRegistrationStep'
import UpgradeAccountToIndividualFifthStep from '../components/registration/registrationSteps/UpgradeAccountToIndividualFifthStep'
import FourthRegistrationStep from '../components/registration/registrationSteps/FourthRegistrationStep'
import FifthRegistrationStep from '../components/registration/registrationSteps/FifthRegistrationStep'
import { ReactComponent as IconEasyPayLogo } from '../icons/epIconNew.svg';
import { ReactComponent as IconClose } from '../icons/closeButton.svg';
import { Button,Typography, Grid } from '@mui/material';
import colors from '../components/colors'
import Lottie from "lottie-react";
import smallLoadingAnimation from '../icons/lottieAnimations/smallLoading.json'
import { useSelector, useDispatch } from 'react-redux';
import {selectRegistrationState, resetRegistrationState, setCurrentRegistrationStep, setAccountType} from '../features/registration/registrationSlice'
import { useNavigate, useLocation }  from "react-router-dom";
import {setUserInfoAccountType} from '../features/userInfo/userInfoSlice'
import {setIsLoggedIn, setGlobalDataAccountType} from '../features/global/globalDataSlice'
import {sendGeneralRequest} from '../features/generalRequest'
import {texts} from '../components/general/texts'
import {resetPaymentsSlice} from '../features/payments/paymentsSlice'
import InformativeScaDialog from '../components/general/sca/InformativeScaDialog'
// import EnterReferedCode from '../components/main/inviteFriend/EnterReferedCode'

const Register = () => 
{
    const registrationSliceState = useSelector(selectRegistrationState) 
    // const routerProps = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = useState('')

    const[state, setState] = React.useState({
        currentStep: -1,
    })

    const handleClose = () => 
    {
        dispatch(resetRegistrationState())
        navigate('/login')
    }

    const handleCloseDialog = () => {
        setIsOpen(false)
    }

    React.useEffect(()=>{   
        setState({...state, currentStep: registrationSliceState.currentRegistrationStep})
        if(registrationSliceState.isRegistrationFinished)
        {
            if (registrationSliceState.accountType == 1){
                // dispatch(sendGeneralRequest({request: { token: registrationSliceState.token }, baseUrlKey:'services', endpoint:'InviteFriend/CheckInviteFriend'})).then(response => {
                //     if (response.payload.response.success){
                //         setIsOpen(true)
                //     }
                //     else {
                //         navigate('/dashboard') 
                //     }
                //   })
                setIsOpen(true)
            }
            else {
                //3 //2
                dispatch(setUserInfoAccountType(Number(registrationSliceState.accountType)))
                dispatch(setGlobalDataAccountType(Number(registrationSliceState.accountType)))
                dispatch(resetPaymentsSlice()) 
                dispatch(setIsLoggedIn(true))
                navigate('/dashboard')
            }
        }
        
        /*return () => {
            dispatch(setIsUpgrading(false))
        }*/
    },[registrationSliceState.currentRegistrationStep, registrationSliceState.isRegistrationFinished])

    React.useEffect(()=>{
        if(registrationSliceState.isUpgrading){
            setState({...state, currentStep: 3})
            dispatch(setCurrentRegistrationStep(3))
            dispatch(setAccountType('1'))
        }
        if(registrationSliceState.isValidatingPhone){
            setState({...state, currentStep: 1})
            dispatch(sendGeneralRequest({request: {token: registrationSliceState.token, phone: registrationSliceState.phone, prefix: registrationSliceState.prefix}, baseUrlKey:'auth', endpoint: 'ValidatePhone'}))
            dispatch(setCurrentRegistrationStep(1))
        }
        if(registrationSliceState.isValidatingEmail){
            setState({...state, currentStep: 2})
            dispatch(sendGeneralRequest({request: {_request: {token: registrationSliceState.token}}, baseUrlKey:'auth', endpoint: 'SendConfirmationLink'}))
            dispatch(setCurrentRegistrationStep(2))
        }
        if(registrationSliceState.isPickingIndividualOrExpressAccountType){
            setState({...state, currentStep: 3})
            dispatch(setCurrentRegistrationStep(3))
        }
    },[])

    return(
        <Grid container justifyContent={'center'} padding={'0.8%'}>
            <Grid item md={6} mt={3} display={{xs :'none', md:'block'}} >
                <IconEasyPayLogo width={'20%'} />
            </Grid>
            <Grid container item md={6} xs={10} marginBottom={9} paddingTop={3} justifyContent={'center'} sx={{'@media (max-width: 899px)' : {justifyContent:'right'}}} >
                <Button sx={{ borderRadius:'20px',":hover":{backgroundColor:colors.lightOrange}}} onClick={handleClose}><IconClose/></Button>  
            </Grid>
            {
                state.currentStep !== -1 && 
                <>
                    <Grid item md={12} xs={12} marginBottom={8.5}>
                        <Typography sx={{fontFamily:'GerberaBold', fontSize:'2rem', color:colors.darkBlue}} >{texts["message-join-revolution"]}</Typography>
                    </Grid>
                    <Grid container item md={12} xs={12} justifyContent='center' marginBottom={12}>
                        <Stepper steps={['1','2','3','4','5']} currentStep={state.currentStep}/>
                    </Grid>
                </>
            }
            <Grid  item md={12} xs={12} >
                {state.currentStep === -1 && <IndividualOrBusinessAccountTypes/>}
                {state.currentStep === 0 && <FirstRegistrationStep/>}
                {state.currentStep === 1 && <SecondRegistrationStep/>}
                {state.currentStep === 2 && <ThirdRegistrationStep/> }
                {state.currentStep === 3 && <FourthRegistrationStep/>}
                {state.currentStep === 4 && (registrationSliceState.isUpgrading ? <UpgradeAccountToIndividualFifthStep/> : (registrationSliceState.accountType === 1 ? <FifthRegistrationStep/> : (registrationSliceState.accountType === 2 ? <BusinessAccountFifthRegistrationStep/> : <BasicAccountFifthRegistrationStep/>))) }
            </Grid>
            <Grid item md={0.6} xs={0.6} >
                {registrationSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}   
            </Grid>       
             {/* <EnterReferedCode isDialogOpened={isOpen} handleClose={handleCloseDialog}/>      */}
             <InformativeScaDialog isDialogOpened={isOpen} handleClose={handleCloseDialog} />
        </Grid>
    )
}
export default Register